import {PriceTierWithHasProductsFlag} from '@treez/commons/sharedTypings/priceTier';
import {OrganizationWithCatalogsAttributesAndPriceTiers} from '~/lib/entity';

export enum OrganizationAction {
    INVALIDATE_ORGANIZATION_REQUEST = 'INVALIDATE_ORGANIZATION_REQUEST',
    LOAD_ORGANIZATION = 'LOAD_ORGANIZATION',
    REQUEST_ORGANIZATION = 'REQUEST_ORGANIZATION',
    UPDATE_PRICE_TIERS = 'UPDATE_PRICE_TIERS',
    UPDATE_PRICE_TIER = 'UPDATE_PRICE_TIER',
}

const {
    INVALIDATE_ORGANIZATION_REQUEST,
    LOAD_ORGANIZATION,
    REQUEST_ORGANIZATION,
    UPDATE_PRICE_TIERS,
    UPDATE_PRICE_TIER,
} = OrganizationAction;

export const recieveOrganizationInformation = (
    organization: OrganizationWithCatalogsAttributesAndPriceTiers
) => {
    return {
        type: LOAD_ORGANIZATION,
        value: organization,
    };
};

export const updatePriceTiers = (priceTiers: PriceTierWithHasProductsFlag[]) => {
    return {
        type: UPDATE_PRICE_TIERS,
        value: priceTiers,
    };
};

export const replacePriceTier = (priceTier: PriceTierWithHasProductsFlag) => {
    return {
        type: UPDATE_PRICE_TIER,
        value: priceTier,
    };
};

export const fetchOrganizationDetails = () => ({
    type: REQUEST_ORGANIZATION,
});

export const invalidateOrganizationRequest = () => ({
    type: INVALIDATE_ORGANIZATION_REQUEST,
});
